import heroMagAsset from "@/assets/product-hero/mag-absorb-hero.png.asset.json";
import heroOvaAsset from "@/assets/product-hero/ova-balance-hero.png.asset.json";
import heroLiverAsset from "@/assets/liver-biome-v2/01-hero.webp.asset.json";

export const HERO_MAG = heroMagAsset.url;
export const HERO_OVA = heroOvaAsset.url;
export const HERO_LIVER = heroLiverAsset.url;

/**
 * Resolves the PDP hero image for a product from any loose reference
 * (product title, handle, or an order line-item title).
 */
export function getProductHeroImage(...refs: Array<string | null | undefined>): string | null {
  const s = refs.filter(Boolean).join(" ").toLowerCase();
  if (!s) return null;
  if (s.includes("mag") || s.includes("absorb")) return HERO_MAG;
  if (s.includes("ova")) return HERO_OVA;
  if (s.includes("liver") || s.includes("biome")) return HERO_LIVER;
  return null;
}
